import React from "react";

import FlickeringGrid from "@/components/magicui/flickeringGrid";
import { InfiniteMovingCards } from "@/components/ui/infinite-moving-cards";
import * as m from "@/paraglide/messages";
const testimonials = (m: any) => [
  {
    quote: m.testimonial1(),
    name: "Mathieu",
    title: "",
  },
  {
    quote: m.testimonial2(),
    name: "Yann",
    title: "",
  },
  {
    quote: m.testimonial3(),
    name: "Julien",
    title: "",
  },
  {
    quote: m.testimonial4(),
    name: "Louis",
    title: "",
  },
  {
    quote: m.testimonial5(),
    name: "Jeremie",
    title: "",
  },
  {
    quote: m.testimonial6(),
    name: "Arthur",
    title: "",
  },
];

export default function Testimonials() {
  return (
    <section className="py-16 bg-gradiant-light flex flex-col antialiased  items-center justify-center relative overflow-hidden">
      <FlickeringGrid
        className="[mask-image:radial-gradient(ellipse_at_bottom,white,transparent,transparent)] z-0 absolute  inset-0 size-full"
        squareSize={2}
        gridGap={8}
        color="#6B7280"
        maxOpacity={0.6}
        flickerChance={0.3}
        height={500}
      />
      <h2
        className=" text-center text-transparent dark:from-black/90 dark:to-black/40 animate-fade-up  opacity-0 text-2xl lg:text-4xl font-extrabold tracking-tight leading-normal   pb-4 text-balance bg-gradient-to-br from-black from-30% to-black/60 bg-clip-text"
        style={{ animationDelay: "0.25s", animationFillMode: "forwards" }}
      >
        {m.fair_sad_toad_twirl()}
      </h2>
      <InfiniteMovingCards
        items={testimonials(m)}
        direction="left"
        speed="slow"
      />
    </section>
  );
}
